export const shouldPreserveSavedGHGTable = (doc, element) => {
  if (!doc || !element?.key) {
    return false;
  }

  if (!['TYPE_5_TABLE', 'TYPE_6_TABLE', 'TYPE_7_TABLE'].includes(element.keyValueType)) {
    return false;
  }

  const holder = doc.getElementById(`typeTableHolder-${element.key}`);
  if (!holder) {
    return false;
  }

  return holder.innerHTML.replace(/<!--[\s\S]*?-->/g, '').trim().length > 0;
};
